'use client';

import { Button } from '@sortlist-frontend/design-system/ssr';

import { OPEN_BRIEFING, useBriefingMessage } from '_components/Briefing/versions/NormalBriefing/BriefingDialog';
import { NavigationData } from '_components/layout/Layout';

type Props = {
  label?: string;
  navigationData: NavigationData;
};

export const AgencyCtaBriefingCta = (props: Props) => {
  const { label, navigationData } = props;
  const { sendMessage } = useBriefingMessage();

  return (
    <Button
      size={'sm'}
      buttonStyle="primary"
      buttonVariant="raised"
      className="mt-4"
      data-testid="briefing-agency-btn"
      label={label}
      onClick={() => {
        sendMessage(OPEN_BRIEFING, { cta: 'card-cta', expertiseId: navigationData.expertiseId });
      }}
    />
  );
};
